import './Image.less'
import Image from './Image'
export default Image
